import {createEntityAdapter, EntityState} from '@ngrx/entity';
import { PracticeTypeEntity } from '../../../entities/mdqx/practice-type.entity';
import { PracticeTypeActions, PracticeTypeActionTypes } from '../../actions/mdqx/practice-type.actions';

export interface PracticeTypeState extends EntityState<PracticeTypeEntity> {
    fetched: boolean;
}

export const PRACTICE_TYPE_KEY = 'practiceType';

const adapter = createEntityAdapter<PracticeTypeEntity>({
    selectId: practiceType => practiceType.Id
});

const initialState = adapter.getInitialState({
    fetched: false
});

/* ############# */
/* ## REDUCER ## */
/* ############# */

export function practiceTypeReducer(state = initialState, action: PracticeTypeActions) {
    switch (action.type) {
        case PracticeTypeActionTypes.GetPracticeTypesResponse: {
            return adapter.setAll(action.Payload, {...state, fetched: true});
        }

        default: {
            return state;
        }
    }
}

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const {selectAll} = adapter.getSelectors();

export const selectAllPracticeTypes = selectAll;

export const selectPracticeTypesFetched = (state: PracticeTypeState) => state.fetched;
